export enum TransientTypes {
  cdd,
  partsportal
}



// WEBPACK FOOTER //
// ./src/app/models/TransientTypes.ts